// extracted by mini-css-extract-plugin
export default {"frame":"GalleryView_frame__Sx2BT","icon":"GalleryView_icon__rTJCD","left":"GalleryView_left__LaBtd","right":"GalleryView_right__s3LzY"};